import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";

import { resolveIconHref } from "./icon.constants";
import { IconSpriteService } from "./icon-sprite.service";

@Component({
	selector: "azm-icon",
	imports: [TranslocoPipe],
	templateUrl: "./icon.component.html",
	styleUrl: "./style/icon.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
	private readonly sprite = inject(IconSpriteService);

	name = input.required<string>();
	size = input<number | string>(20);
	iconClass = input<string>("");
	ariaHidden = input(true);
	ariaLabel = input<string | null>(null);

	readonly href = computed(() => resolveIconHref(this.name(), this.sprite.ready()));

	readonly resolvedAriaLabel = computed(() => {
		const label = this.ariaLabel();
		return label && !this.ariaHidden() ? label : null;
	});
}
